import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.STORAGE_DAYS, days)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.STORAGE_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.STORAGE_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.STORAGE_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.STORAGE_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.STORAGE_FILTER_BY, filterBy)
  },
  [types.SET_STORAGE](state, data) {
    state.storage = []
    if (data !== undefined && data !== null) {
      state.storage = data
    }
  },
  [types.SET_ACCOUNT](state, data) {
    state.account = null
    if (data !== undefined && data !== null) {
      state.account = data
    }
  },
  [types.SET_BUCKET_CONTENTS](state, data) {
    state.account = null
    if (data !== undefined && data !== null) {
      state.bucketContents = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/storage/mutations.js